import { useParams } from 'react-router-dom';
import CapturesGallery from '../components/CapturesGallery';

export default function ProjectCaptures() {
  const { id } = useParams<{ id: string }>();
  if (!id) return null;
  return (
    <>
      <div className="card" style={{ marginBottom: 12 }}>
        <div className="card-title">Galerie Captures 3D</div>
        <div className="card-meta">
          Toutes les captures prises depuis le viewer IFC du projet. Clique pour agrandir, renomme
          ou supprime. Ces captures sont réutilisables dans les synthèses.
        </div>
      </div>
      <CapturesGallery projectId={Number(id)} />
    </>
  );
}
